"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = result;
var _isFunction = _interopRequireDefault(require("./isFunction.js"));
var _toPath = _interopRequireDefault(require("./_toPath.js"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
// Traverses the children of `obj` along `path`. If a child is a function, it
// is invoked with its parent as context. Returns the value of the final
// child, or `fallback` if any child is undefined.
function result(obj, path, fallback) {
  path = (0, _toPath.default)(path);
  var length = path.length;
  if (!length) {
    return (0, _isFunction.default)(fallback) ? fallback.call(obj) : fallback;
  }
  for (var i = 0; i < length; i++) {
    var prop = obj == null ? void 0 : obj[path[i]];
    if (prop === void 0) {
      prop = fallback;
      i = length; // Ensure we don't continue iterating.
    }
    obj = (0, _isFunction.default)(prop) ? prop.call(obj) : prop;
  }
  return obj;
}